module.exports = __webpack_public_path__ + "static/media/YF61_1.d4aa2b4b.jpg";